export default "__VITE_ASSET__CMoekCEF__"